import { useState, useEffect } from "react";
import { translations } from "@/i18n";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Gallery from "@/components/landing/Gallery";
import Locations from "@/components/landing/Locations";
import Reviews from "@/components/landing/Reviews";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function BodegonNunez() {
  const [lang, setLang] = useState("es");
  const t = translations[lang];

  useEffect(() => {
    document.title =
      lang === "es"
        ? "Bodegón Núñez — El más grande · Palermo & Núñez"
        : "Bodegón Núñez — The biggest one · Palermo & Núñez";
  }, [lang]);

  return (
    <div className="min-h-screen bg-bn-bg text-bn-text font-body" data-testid="landing-page">
      <Navbar lang={lang} setLang={setLang} t={t} />
      <Hero t={t} />
      <About t={t} />
      <Gallery t={t} />
      <Locations t={t} />
      <Reviews t={t} lang={lang} />
      <Contact t={t} />
      <Footer t={t} />
    </div>
  );
}
